import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import {
    SocialServiceOperationCreateInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-operation.create-input';
import {
    SocialServiceOperationPatchInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-operation.patch-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import {
    SocialServiceRegionPatchInput
} from '@libs/types/src/services/input-type/services/social-service/social-service-region.patch-input';
import {
    SocialServiceRegionCreateInput
} from '@libs/types/src/services/input-type/services/social-service/social-service-region.create-input';
import {
    SocialServiceResidualPercentPatchInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-residual-percent.patch-input';
import {
    SocialServiceResidualPercentCreateInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-residual-percent.create-input';
import {
    SocialServiceOperationProcedurePatchInput
} from '@libs/types/src/services/input-type/services/social-service/social-service-operation-procedure.patch-input';
import {
    SocialServiceOperationProcedureCreateInput
} from '@libs/types/src/services/input-type/services/social-service/social-service-operation-procedure.create-input';
import {
    SocialServiceOperationGridObject,
    SocialServiceOperationObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-operation.object';
import { OkObject } from '@it2go/types';
import {
    SocialServiceRegionGridObject,
    SocialServiceRegionObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-region.object';
import {
    SocialServiceResidualPercentGridObject,
    SocialServiceResidualPercentObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-residual-percent.object';
import {
    SocialServiceOperationProcedureGridObject,
    SocialServiceOperationProcedureObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-operation-procedure.object';
import {
    SocialServiceOfferGridObject,
    SocialServiceOfferObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-offer.object';
import {
    SocialServiceOfferPatchInput
} from '@libs/types/src/services/input-type/services/social-service/social-service-offer.patch-input';
import {
    SocialServiceOfferCreateInput
} from '@libs/types/src/services/input-type/services/social-service/social-service-offer.create-input';
import {
    SocialServiceOfferEnsureInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-offer-ensure.input';
import {
    SocialServiceOfferEnsureObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-offer-ensure.object';

@Injectable({ providedIn: 'root' })
export class ServiceTypeSettingsGqlService extends GqlServiceV2 {

    public getSocialServiceOperations(input: GridInput, fragment: string) {
        return this.query<SocialServiceOperationGridObject>(
            `
                query($input: GridInput!) {
                    socialServiceOperation {
                        filter(input: $input) {
                            ${filterFrag} 
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialServiceOperation(input: SocialServiceOperationCreateInput, fragment: string) {
        return this.mutate<SocialServiceOperationObject>(
            `
                mutation($input: SocialServiceOperationCreateInput!) {
                    socialServiceOperation {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchSocialServiceOperation(input: SocialServiceOperationPatchInput, fragment: string) {
        return this.mutate<SocialServiceOperationObject>(
            `
                mutation($input: SocialServiceOperationPatchInput!) {
                    socialServiceOperation {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialServiceOperation(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialServiceOperation {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSocialServiceOperationProcedures(input: GridInput, fragment: string) {
        return this.query<SocialServiceOperationProcedureGridObject>(
            `
                query($input: GridInput!) {
                    socialServiceOperationProcedure {
                        filter(input: $input) {
                            ${filterFrag} 
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialServiceOperationProcedure(input: SocialServiceOperationProcedureCreateInput, fragment: string) {
        return this.mutate<SocialServiceOperationProcedureObject>(
            `
                mutation($input: SocialServiceOperationProcedureCreateInput!) {
                    socialServiceOperationProcedure {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchSocialServiceOperationProcedure(input: SocialServiceOperationProcedurePatchInput, fragment: string) {
        return this.mutate<SocialServiceOperationProcedureObject>(
            `
                mutation($input: SocialServiceOperationProcedurePatchInput!) {
                    socialServiceOperationProcedure {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialServiceOperationProcedure(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialServiceOperationProcedure {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSocialServiceRegions(input: GridInput, fragment: string) {
        return this.query<SocialServiceRegionGridObject>(
            `
                query($input: GridInput!) {
                    socialServiceRegion {
                        filter(input: $input) {
                            ${filterFrag} 
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialServiceRegion(input: SocialServiceRegionCreateInput, fragment: string) {
        return this.mutate<SocialServiceRegionObject>(
            `
                mutation($input: SocialServiceRegionCreateInput!) {
                    socialServiceRegion {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchSocialServiceRegion(input: SocialServiceRegionPatchInput, fragment: string) {
        return this.mutate<SocialServiceRegionObject>(
            `
                mutation($input: SocialServiceRegionPatchInput!) {
                    socialServiceRegion {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialServiceRegion(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialServiceRegion {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSocialServiceOffers(input: GridInput, fragment: string) {
        return this.query<SocialServiceOfferGridObject>(
            `
                query($input: GridInput!) {
                    socialServiceOffer {
                        filter(input: $input) {
                            ${filterFrag} 
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialServiceOffer(input: SocialServiceOfferCreateInput, fragment: string) {
        return this.mutate<SocialServiceOfferObject>(
            `
                mutation($input: SocialServiceOfferCreateInput!) {
                    socialServiceOffer {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchSocialServiceOffer(input: SocialServiceOfferPatchInput, fragment: string) {
        return this.mutate<SocialServiceOfferObject>(
            `
                mutation($input: SocialServiceOfferPatchInput!) {
                    socialServiceOffer {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialServiceOffer(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialServiceOffer {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public ensureSocialServiceOffersForOperations(input: SocialServiceOfferEnsureInput) {
        return this.mutate<SocialServiceOfferEnsureObject[]>(
            `
                mutation($input: SocialServiceOfferEnsureInput!) {
                    socialServiceOffer {
                        ensureForOperations(input: $input) {
                            operationId
                            offerId
                            created
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSocialServiceResidualPercents(input: GridInput, fragment: string) {
        return this.query<SocialServiceResidualPercentGridObject>(
            `
                query($input: GridInput!) {
                    socialServiceResidualPercent {
                        filter(input: $input) {
                            ${filterFrag} 
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialServiceResidualPercent(input: SocialServiceResidualPercentCreateInput, fragment: string) {
        return this.mutate<SocialServiceResidualPercentObject>(
            `
                mutation($input: SocialServiceResidualPercentCreateInput!) {
                    socialServiceResidualPercent {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchSocialServiceResidualPercent(input: SocialServiceResidualPercentPatchInput, fragment: string) {
        return this.mutate<SocialServiceResidualPercentObject>(
            `
                mutation($input: SocialServiceResidualPercentPatchInput!) {
                    socialServiceResidualPercent {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialServiceResidualPercent(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialServiceResidualPercent {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
